<template>
  <div :class="{ 'homepage-skin-dark': skin === 'dark' }">
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <div>
          <welcome-section />
          <b-row class="match-height">
            <b-col
              cols="12"
              md="3"
            >
              <current-products-overview
                :data="currentProductsData"
                :total="currentProductsTotal"
                :recent="recentProductCount"
                title="Current Products"
                subtitle="Products open for investment"
                :loading="loadingDisplays.productCountLoading"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <ecommerce-goal-overview
                :data="productUniverseData"
                :total="productUniverseTotal"
                :recent="recentMaturedCount"
                title="All Products"
                subtitle="All products on our database: current, live and matured"
                :loading="loadingDisplays.serviceLoading"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <versus-overview
                :data="aimProducts"
                :loading="loadingDisplays.aimTable"
                title="Investment Aims"
                subtitle="Current products by income and growth"
                data-type="aim"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
            >
              <versus-overview
                :data="capitalProducts"
                :loading="loadingDisplays.capitalTable"
                title="Risk to Capital"
                subtitle="Current products by capital protection"
                data-type="capital"
              />
            </b-col>
          </b-row>
          <b-row class="match-height mt-0">
            <b-col
              cols="12"
              md="6"
            >
              <leaderboard-comparison
                :use-icons="false"
                :data="providersProducts.data"
                :loading="loadingDisplays.providersTable"
                title="Providers"
                subtitle="Current products by provider"
                @item-clicked="leaderboardItemClicked"
              />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <leaderboard-comparison
                :use-icons="true"
                :data="productTypes.data"
                :loading="loadingDisplays.productTypesTable"
                title="Product Types"
                subtitle="Current products by structured product type"
                @item-clicked="leaderboardItemClicked"
              />
            </b-col>
          </b-row>
          <b-row v-if="false">
            <b-col>
              <b-card
                no-body
                class="p-0"
              >
                <b-table
                  responsive="sm"
                  hover
                  :items="aimProducts.data"
                  :fields="aimProducts.fields"
                  @row-clicked="(item, index, event) => categoryRowClicked('aim', item.aimType)"
                />
                <div v-if="loadingDisplays.aimTable">
                  <loading-container />
                </div>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                no-body
                class="p-0"
              >
                <b-table
                  responsive="sm"
                  hover
                  :items="capitalProducts.data"
                  :fields="capitalProducts.fields"
                  @row-clicked="(item, index, event) => categoryRowClicked('capital', item.capitalType)"
                />
                <div v-if="loadingDisplays.capitalTable">
                  <loading-container />
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row v-if="false">
            <b-col>
              <b-card
                no-body
                class="p-0"
              >
                <b-table
                  responsive="sm"
                  hover
                  :items="productTypes.data"
                  :fields="productTypes.fields"
                  @row-clicked="(item, index, event) => categoryRowClicked('producttype', item.productType)"
                />
                <div v-if="loadingDisplays.productTypesTable">
                  <loading-container />
                </div>
              </b-card>
            </b-col>
            <b-col>
              <b-card
                no-body
                class="p-0"
              >
                <b-table
                  responsive="sm"
                  hover
                  :items="providersProducts.data"
                  :fields="providersProducts.fields"
                  @row-clicked="(item, index, event) => categoryRowClicked('providers', item.providerType)"
                />
                <div v-if="loadingDisplays.providersTable">
                  <loading-container />
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <b-card v-if="false">
          <h2 class="mb-2">
            Filter and select
          </h2>
          <p>
            Comprehensive product filter allowing you to select products according to risk, aims, wrappers, product types, providers, issuers and more.
            This allows you to see the relevant products and then instantly evidence your selection with our Product selection record for better compliance.
          </p>
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              to="/report-center"
            >
              Start product filter and selection record
            </b-button>
          </div>

        </b-card>

        <b-row class="match-height">
          <b-col
            cols="12"
            md="4"
          >
            <b-card class="home-chart-card-with-hint">
              <hint-popup
                :id="5"
                class="home-card-hint-popup"
              />
              <b-card-title class="mb-0">
                Yearly Product Issuance
              </b-card-title>
              <div class="font-small-3 mb-1 text-muted">
                Issuance patterns monthly for last five years
              </div>
              <b-card-text>
                <div style="min-height: 370px; height: 370px;">
                  <div v-if="wormChartLoading">
                    <loading-container />
                  </div>
                  <app-echart-line
                    v-else-if="wormChartData.series && wormChartData.series.length > 0"
                    :key="wormChartKey"
                    :option-data="wormChartData"
                    style="height: 100%; width: 100%;"
                  />
                  <div v-else>
                    <p>No data available</p>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="home-chart-col"
          >
            <portfolio-evolution-chart
              class="home-chart-card-with-hint"
              portfolio-type="u"
              :evolution-data="evolutionChartData"
              :index-underlying-vol-ratio="indexUnderlyingVolRatio"
              :show-index-selector="false"
              subtitle="Calculated Indices of structured products and benchmarks"
            >
              <template #hint>
                <hint-popup
                  :id="6"
                  class="home-card-hint-popup"
                />
              </template>
            </portfolio-evolution-chart>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="home-chart-col"
          >
            <payoff-scatter-chart
              class="home-chart-card-with-hint"
              :payoff-scatter="payoffScatterData"
              :year-only="true"
              :is-homepage="true"
            >
              <template #hint>
                <hint-popup
                  :id="7"
                  class="home-card-hint-popup"
                />
              </template>
            </payoff-scatter-chart>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="d-flex flex-wrap align-items-center mb-2 mt-2">
              <h1 class="mb-0 mr-2">
                Find Out More
              </h1>
              <b-button
                variant="outline-secondary"
                size="sm"
                class="d-flex align-items-center"
                :href="`${baseURL}downloadseflyerpdf.cfm`"
                target="_blank"
                rel="noopener"
              >
                <b-img
                  :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
                  height="20"
                  style="width: auto;"
                  alt="PDF"
                />
                <span
                  class="ml-50 font-weight-bold text-body"
                  style="position: relative; top: 2px;"
                >Structured Edge flyer</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                size="sm"
                class="d-flex align-items-center ml-1"
                :href="`${baseURL}downloadsepremiumpdf.cfm`"
                target="_blank"
                rel="noopener"
              >
                <b-img
                  :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
                  height="20"
                  style="width: auto;"
                  alt="PDF"
                />
                <span
                  class="ml-50 font-weight-bold text-body"
                  style="position: relative; top: 2px;"
                >Premium version</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row class="match-height homepage-content-row">
          <b-col
            v-for="column in homepageContentColumns"
            :key="column.id"
            cols="12"
            md="4"
          >
            <b-card
              :title="column.title"
              class="homepage-content-card"
            >
              <b-card-text
                v-if="column.htmlContent"
                class="homepage-content-text"
              >
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="column.htmlContent" />
              </b-card-text>
            </b-card>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <b-card
              title="Updates"
              class="homepage-content-card recent-developments-card home-chart-card-with-hint"
            >
              <hint-popup
                :id="8"
                class="home-card-hint-popup"
              />
              <div v-if="recentDevelopments.loading">
                <loading-container />
              </div>
              <div v-else>
                <b-table
                  responsive
                  hover
                  show-empty
                  small
                  class="recent-developments-table"
                  :items="recentDevelopments.items"
                  :fields="recentDevelopments.fields"
                  :current-page="recentDevelopments.currentPage"
                  :per-page="recentDevelopments.perPage"
                  @row-clicked="toggleRecentDevelopmentDetails"
                >
                  <template #cell(datepublished)="data">
                    {{ formatIsoDate(data.item.datepublished) }}
                  </template>

                  <template #row-details="row">
                    <div class="recent-development-details">
                      <p
                        v-if="row.item.introduction"
                        class="recent-development-introduction"
                      >
                        {{ row.item.introduction }}
                      </p>
                      <div class="recent-development-actions">
                        <b-button
                          v-if="row.item.pdfurl"
                          size="sm"
                          variant="outline-primary"
                          class="recent-development-action-button recent-development-pdf-button"
                          :href="`${baseURL}${row.item.pdfurl}`"
                          target="_blank"
                          title="Open PDF"
                        >
                          <b-img
                            height="26"
                            :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
                            alt="PDF"
                            class="recent-development-pdf-icon"
                          />
                          <span>Open PDF</span>
                        </b-button>
                        <b-button
                          v-if="row.item.weblink"
                          size="sm"
                          variant="outline-primary"
                          class="recent-development-action-button"
                          :href="row.item.weblink"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit link{{ row.item.webname ? ` (${row.item.webname})` : '' }}
                        </b-button>
                      </div>
                    </div>
                  </template>
                </b-table>

                <div
                  v-if="recentDevelopments.items.length > 0"
                  class="recent-developments-pagination"
                >
                  <b-form-select
                    v-model="recentDevelopments.perPage"
                    :options="recentDevelopments.perPageOptions"
                    size="sm"
                  />
                  <b-pagination
                    v-model="recentDevelopments.currentPage"
                    :total-rows="recentDevelopments.items.length"
                    :per-page="recentDevelopments.perPage"
                    size="sm"
                    class="mb-0"
                  />
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>

      <!-- <b-col
        v-if="false"
        cols="12"
        md="4"
      >
        <b-card
          title="Your usage"
          border-variant="primary"
        >
          <my-usage-card-content />

          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              to="/account/your-usage"
            >
              Go To Your Usage
            </b-button>
          </div>
        </b-card>
        <b-card
          title="Quick start"
          border-variant="primary"
        >
          <b-card-text>
            Introducing the features and benefits of StructuredEdge and how to get started easily
          </b-card-text>

          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              to="/help/quickstart"
            >
              Go To Quick start
            </b-button>
          </div>
        </b-card>
        <b-card
          title="Filter and select"
          border-variant="primary"
        >
          <b-card-text>
            Filter available products and instantly generate a product selection record
          </b-card-text>

          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              to="/report-center"
            >
              Go To Filter and select
            </b-button>
          </div>
        </b-card>
        <b-card
          title="Head-to-head"
          border-variant="primary"
        >
          <b-card-text>
            Compare up to four products side-by-side
          </b-card-text>

          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              to="/help/quickstart"
            >
              Go To Head-to-head
            </b-button>
          </div>
        </b-card>

        <hr class="my-2">

        <b-card title="FVC Hub">
          <fvc-hub-content />

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            href="http://www.futurevc.co.uk/hub.cfm"
            class="mt-3"
          >
            FVC Hub
          </b-button>
        </b-card>
      </b-col> -->
    </b-row>
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BFormSelect,
  BImg,
  BPagination,
  // BCarousel,
  // BCarouselSlide,
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { $themeConfig } from '@themeConfig'
import FvcHubContent from '@/views/components/FvcHubContent.vue'
import WelcomeSection from '@/views/components/home/WelcomeSection.vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import PortfolioEvolutionChart from '@/views/products/portfolio/charts/PortfolioEvolutionChart.vue'
import PayoffScatterChart from '@/views/products/portfolio/charts/PayoffScatterChart.vue'
import EcommerceGoalOverview from '@/views/ecommerce/EcommerceGoalOverview.vue'
import CurrentProductsOverview from '@/views/ecommerce/CurrentProductsOverview.vue'
import VersusOverview from '@/views/ecommerce/VersusOverview.vue'
import LeaderboardComparison from '@/views/ecommerce/LeaderboardComparison.vue'
import HintPopup from '@/views/components/HintPopup.vue'
import {
  getHomepageContentById,
  toHomepageContentViewModel,
} from '@/services/homepageContentService'
import { formatIsoDate } from '@/utils/formatters'

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BFormSelect,
    BImg,
    BPagination,
    // BCarousel,
    // BCarouselSlide,
    BRow,
    BCol,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    FvcHubContent,
    WelcomeSection,
    LoadingContainer,
    AppEchartLine,
    PortfolioEvolutionChart,
    PayoffScatterChart,
    EcommerceGoalOverview,
    CurrentProductsOverview,
    VersusOverview,
    LeaderboardComparison,
    HintPopup,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    return { skin }
  },
  data() {
    return {
      loadingDisplays: {
        productCountLoading: true,
        serviceLoading: true,
        aimTable: true,
        capitalTable: true,
        productTypesTable: true,
        providersTable: true,
      },
      currentProductCount: [
        {
          icon: 'GridIcon',
          color: 'light-info',
          title: '',
          subtitle: 'Current products',
          customclass: 'mb-2 mb-xl-0',
        },
      ],
      recentProductCount: 0,
      recentMaturedCount: 0,
      aimProducts: [],
      capitalProducts: [],
      productTypes: [],
      providersProducts: [],
      serviceLoading: true,
      serviceError: false,
      lifecycleOverview: {
        servicename: '',
        updated: '',
        productUniverse: [
          {
            icon: '',
            color: '',
            title: '',
            subtitle: '',
            customclass: '',
          },
        ],
      },
      wormChartLoading: true,
      wormChartKey: 0,
      wormChartData: {
        xAxis: {},
        yAxis: {},
        series: [],
      },
      wormChartRawData: null,
      evolutionChartData: null,
      indexUnderlyingVolRatio: null,
      payoffScatterData: null,
      productUniverseData: {
        series: [],
      },
      productUniverseTotal: 0,
      baseURL: process.env.VUE_APP_BACKEND_PATH,
      homepageContentRecords: {
        0: null,
        1: null,
      },
      recentDevelopments: {
        loading: true,
        items: [],
        fields: [
          {
            key: 'datepublished',
            label: 'Date',
            thClass: 'recent-development-date-column',
          },
          {
            key: 'title',
            label: 'Subject',
          },
        ],
        currentPage: 1,
        perPage: 10,
        perPageOptions: [10, 20, 50],
      },
      loginStatistics: [
        {
          icon: 'LogInIcon',
          color: 'light-primary',
          title: '23',
          subtitle: 'Your Logins',
          customClass: 'mb-2 mb-md-0',
        },
        {
          icon: 'ClockIcon',
          color: 'light-success',
          title: '3.2h',
          subtitle: 'Time Spent',
          customClass: 'mb-2 mb-md-0',
        },
        {
          icon: 'ActivityIcon',
          color: 'light-info',
          title: '142',
          subtitle: 'Actions Taken',
          customClass: 'mb-2 mb-md-0',
        },
        {
          icon: 'TrendingUpIcon',
          color: 'light-warning',
          title: '+15%',
          subtitle: 'vs Last Week',
          customClass: 'mb-2 mb-md-0',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn',
      'isPremium',
    ]),
    brand() {
      return $themeConfig.app.brand
    },
    splitLineOpacity() {
      return this.skin === 'dark' ? 0.1 : 1
    },
    currentProductsData() {
      const count = parseInt(this.currentProductCount[0].title, 10) || 0
      return { series: [count] }
    },
    currentProductsTotal() {
      return parseInt(this.currentProductCount[0].title, 10) || 0
    },
    homepageContentColumns() {
      return [
        {
          id: 'homepage-content-0',
          ...toHomepageContentViewModel(this.homepageContentRecords[0], this.isPremium),
        },
        {
          id: 'homepage-content-1',
          ...toHomepageContentViewModel(this.homepageContentRecords[1], this.isPremium),
        },
      ]
    },
  },
  watch: {
    skin() {
      // Re-process worm chart data when theme changes
      if (this.wormChartRawData) {
        this.processWormChartData(this.wormChartRawData)
        this.wormChartKey += 1
      }
    },
  },
  created() {
    this.loadProductCount()
    this.loadAimsData()
    this.loadCapitalData()
    this.loadProductTypesData()
    this.loadProvidersData()
    this.loadLifecycleOverview()
    this.loadWormChartData()
    this.loadEvolutionChartData()
    this.loadPayoffScatterData()
    this.loadProductUniverseCounts()
    this.loadHomepageContent()
    this.loadRecentDevelopments()
  },
  methods: {
    formatIsoDate,
    loadHomepageContent() {
      const homepageContentIds = [0, 1]

      homepageContentIds.forEach(id => {
        getHomepageContentById(id)
          .then(record => {
            this.$set(this.homepageContentRecords, id, record)
          })
          .catch(() => {
            this.$set(this.homepageContentRecords, id, null)
          })
      })
    },
    loadRecentDevelopments() {
      this.recentDevelopments.loading = true

      this.$http
        .get('public.cfc?method=getRecentDevelopments')
        .then(response => {
          const items = response.data.ITEMS || response.data.items || []

          this.recentDevelopments.items = items.map(item => {
            const webLinkFromDatabase = item.WEBLINK || item.weblink || ''
            let webLinkForButton = webLinkFromDatabase

            if (webLinkFromDatabase && !/^https?:\/\//i.test(webLinkFromDatabase)) {
              webLinkForButton = `https://${webLinkFromDatabase}`
            }

            return {
              id: item.ID,
              datepublished: item.DATEPUBLISHED,
              title: item.TITLE,
              subtype: item.SUBTYPE,
              introduction: item.INTRODUCTION,
              pdfurl: item.PDFURL,
              weblink: webLinkForButton,
              webname: (item.WEBNAME || item.webname || '').trim(),
            }
          })
        })
        .catch(() => {
          this.recentDevelopments.items = []
        })
        .then(() => {
          this.recentDevelopments.loading = false
        })
    },
    toggleRecentDevelopmentDetails(item) {
      // Toggle the clicked table row's expanded details section.
      // eslint-disable-next-line no-underscore-dangle
      this.$set(item, '_showDetails', !item._showDetails)
    },
    loadProductCount() {
      this.loadingDisplays.productCountLoading = true
      this.$http
        .get('public.cfc?method=getProductCount')
        .then(response => {
          this.currentProductCount[0].title = response.data.TOTAL
          this.recentProductCount = response.data.RECENT
          this.loadingDisplays.productCountLoading = false
        })
        // eslint-disable-next-line no-unused-vars
        .catch(_ => {
          this.loadingDisplays.productCountLoading = true
        })
    },
    loadAimsData() {
      this.loadingDisplays.aimTable = true
      this.$http
        .get('public.cfc?method=getAim')
        .then(response => {
          this.aimProducts = response.data
          this.loadingDisplays.aimTable = false
        })
    },
    loadCapitalData() {
      this.loadingDisplays.capitalTable = true
      this.$http
        .get('public.cfc?method=getCapital')
        .then(response => {
          this.capitalProducts = response.data
          this.loadingDisplays.capitalTable = false
        })
    },
    loadProductTypesData() {
      this.loadingDisplays.productTypesTable = true
      this.$http
        .get('public.cfc?method=getCurrentProductTypes')
        .then(response => {
          this.productTypes = response.data
          this.loadingDisplays.productTypesTable = false
        })
    },
    loadProvidersData() {
      this.loadingDisplays.providersTable = true
      this.$http
        .get('public.cfc?method=getCurrentProviders')
        .then(response => {
          this.providersProducts = response.data
          this.loadingDisplays.providersTable = false
        })
    },
    categoryRowClicked(categoryKey, categoryValue) {
      this.$router.push({
        name: 'current-products',
        params: {
          category: categoryKey,
          value: categoryValue,
        },
      })
    },
    leaderboardItemClicked(payload) {
      this.$router.push({
        name: 'current-products',
        params: {
          category: payload.category,
          value: payload.value,
        },
      })
    },
    loadLifecycleOverview() {
      this.loadingDisplays.serviceLoading = true

      // Reset Error flag
      this.serviceError = null

      this.$http
        .get('lifecycle/public/data.cfc?method=getHomePage')
        .then(response => {
          this.lifecycleOverview.servicename = response.data.info.servicename
          this.lifecycleOverview.updated = response.data.info.updated
          this.lifecycleOverview.productUniverse = response.data.data.productuniverse.items
        })
        .catch(error => {
          console.log('Service Loading Error: ', error)
          this.serviceError = true
        })
        .then(() => {
          this.loadingDisplays.serviceLoading = false
        })
    },
    routeToRegistration() {
      this.$router.push('register')
    },
    loadWormChartData() {
      this.wormChartLoading = true
      this.$http
        .get('public.cfc?method=getwormchartdata')
        .then(response => {
          this.wormChartRawData = response.data
          this.processWormChartData(response.data)
          this.wormChartLoading = false
        })
        .catch(error => {
          console.error('Error loading worm chart data:', error)
          this.wormChartLoading = false
        })
    },
    processWormChartData(rawData) {
      const colors = rawData.COLORS || ['#ff9f43', '#1a73e8', '#ea5455', '#28c76f', '#00cfe8']

      // Find min and max values across all series for better y-axis scaling
      let minValue = Infinity
      let maxValue = -Infinity
      rawData.SERIES.forEach(series => {
        series.data.forEach(value => {
          if (value < minValue) minValue = value
          if (value > maxValue) maxValue = value
        })
      })

      // Round to nearest 200
      const yAxisMin = Math.floor(minValue / 200) * 200
      const yAxisMax = Math.ceil(maxValue / 200) * 200

      // Transform series for ECharts
      const echartsSeries = rawData.SERIES.map((series, index) => ({
        name: series.name || `Series ${index + 1}`,
        type: 'line',
        data: series.data,
        smooth: true,
        showSymbol: false,
        lineStyle: {
          width: 2,
          color: colors[index % colors.length],
        },
        itemStyle: {
          color: colors[index % colors.length],
        },
      }))

      // Transform the data for ECharts
      this.wormChartData = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        legend: {
          show: true,
          top: 0,
        },
        grid: {
          left: 70,
          right: 30,
          bottom: 70,
          top: 55,
          containLabel: false,
        },
        xAxis: {
          type: 'category',
          data: rawData.XAXIS,
          boundaryGap: false,
          name: 'Month',
          nameLocation: 'middle',
          nameGap: 35,
          nameTextStyle: {
            fontSize: 13,
            fontWeight: 500,
          },
          axisLabel: {
            fontSize: 12,
            interval: 0,
            formatter: value => (value && value.trim() !== '' ? value : ''),
            showMinLabel: true,
            showMaxLabel: true,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          name: 'Number of Reports',
          nameLocation: 'middle',
          nameGap: 50,
          min: yAxisMin,
          max: yAxisMax,
          nameTextStyle: {
            fontSize: 13,
            fontWeight: 500,
          },
          axisLabel: {
            fontSize: 12,
            formatter: value => value.toFixed(0),
          },
          splitLine: {
            lineStyle: {
              opacity: this.splitLineOpacity,
              type: 'dashed',
            },
          },
        },
        series: echartsSeries,
      }
    },
    loadEvolutionChartData() {
      // First load the sub-index list to get default selections
      this.$http
        .get('lifecycle/public/data.cfc?method=getSubIndexList')
        .then(response => {
          const subIndexList = response.data
          const subIndexListFilter = {}

          // Initialize all category keys first
          subIndexList.forEach(category => {
            subIndexListFilter[category.categoryKey] = []
          })

          // Build filter object with pre-selected indices
          subIndexList.forEach(category => {
            category.items.forEach(item => {
              if (item.isOnHome) {
                subIndexListFilter[category.categoryKey].push(item.value)
              }
            })
          })

          // Now load the chart data with the filter
          return this.$http.get('lifecycle/public/data.cfc?method=getSubIndexData', {
            params: {
              productweightingmode: 'equal',
              indexlistdata: subIndexListFilter,
            },
          })
        })
        .then(response => {
          this.evolutionChartData = response.data
          // Parse volatility value
          const volRatio = response.data?.SHOWDATA?.INDEXUNDERLYINGVOLRATIO
          if (volRatio) {
            const cleanValue = typeof volRatio === 'string' ? volRatio.replace('%', '') : volRatio
            const numValue = parseFloat(cleanValue)
            this.indexUnderlyingVolRatio = Number.isNaN(numValue) ? null : numValue
          }
        })
        .catch(error => {
          console.error('Error loading evolution chart data:', error)
        })
    },
    loadPayoffScatterData() {
      this.$http
        .get('lifecycle/public/report.cfc?method=getUniversePayoffScatter', {
          params: {
            productweightingmode: 'equal',
          },
        })
        .then(response => {
          this.payoffScatterData = response.data.state_payoffscatter
        })
        .catch(error => {
          console.error('Error loading payoff scatter data:', error)
        })
    },
    loadProductUniverseCounts() {
      this.$http
        .get('productfilter.cfc?method=getProductUniverseCounts')
        .then(response => {
          const items = response.data.ITEMS
          const counts = items.map(item => item.count)
          this.productUniverseData = { series: counts }

          this.productUniverseTotal = counts.reduce((sum, count) => sum + count, 0)
          this.recentMaturedCount = response.data.RECENTMATURED

          this.loadingDisplays.serviceLoading = false
        })
        .catch(error => {
          console.error('Error loading product universe counts:', error)
          this.loadingDisplays.serviceLoading = false
        })
    },
  },
}
</script>

<style scoped>
.home-chart-card-with-hint ::v-deep .card-body {
  position: relative;
}

.home-card-hint-popup {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 2;
}

.home-chart-card-with-hint ::v-deep .card-title {
  padding-right: 2.5rem;
}

.homepage-content-row {
  align-items: stretch;
}

.homepage-content-card {
  height: 100%;
}

.homepage-content-card ::v-deep .card-body {
  display: flex;
  flex-direction: column;
}

.homepage-content-card ::v-deep .card-title {
  color: #5e5873;
  font-size: 1.07rem;
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 1.25rem;
}

.homepage-content-text {
  color: #6e6b7b;
  font-size: 0.93rem;
  line-height: 1.55;
  margin-bottom: 0;
}

.homepage-content-text ::v-deep .homepage-column {
  height: 100%;
}

.homepage-content-text ::v-deep p {
  margin-bottom: 0.85rem;
}

.homepage-content-text ::v-deep p:last-child {
  margin-bottom: 0;
}

.homepage-content-text ::v-deep .feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.homepage-content-text ::v-deep .feature-list li {
  margin-bottom: 1rem;
  padding-left: 1.35rem;
  position: relative;
}

.homepage-content-text ::v-deep .feature-list li:last-child {
  margin-bottom: 0;
}

.homepage-content-text ::v-deep .feature-list li::before {
  background: #28c76f;
  border-radius: 50%;
  box-shadow: 0 0 0 0.18rem rgba(40, 199, 111, 0.12);
  content: "";
  height: 0.45rem;
  left: 0;
  position: absolute;
  top: 0.52rem;
  width: 0.45rem;
}

.homepage-content-text ::v-deep .feature-list h3 {
  color: #5e5873;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 0.35rem;
}

.homepage-content-text ::v-deep .feature-list p {
  margin-bottom: 0;
}

.homepage-content-text ::v-deep .homepage-column-premium .feature-list {
  margin: 0.75rem 0 1rem;
}

.homepage-content-text ::v-deep .homepage-column-premium .feature-list li {
  color: #5e5873;
  font-weight: 500;
  margin-bottom: 0.5rem;
  padding-left: 1.5rem;
}

.homepage-content-text ::v-deep .homepage-column-premium .feature-list li::before {
  background: rgba(40, 199, 111, 0.14);
  box-shadow: none;
  height: 0.95rem;
  top: 0.2rem;
  width: 0.95rem;
}

.homepage-content-text ::v-deep .homepage-column-premium .feature-list li::after {
  border-bottom: 2px solid #28c76f;
  border-left: 2px solid #28c76f;
  content: "";
  height: 0.22rem;
  left: 0.28rem;
  position: absolute;
  top: 0.53rem;
  transform: rotate(-45deg);
  width: 0.45rem;
}

.homepage-content-text ::v-deep details {
  background: rgba(115, 103, 240, 0.02);
  border: 1px solid #ebe9f1;
  border-radius: 0.357rem;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.homepage-content-text ::v-deep details:last-child {
  margin-bottom: 0;
}

.homepage-content-text ::v-deep details[open] {
  border-color: rgba(115, 103, 240, 0.35);
  box-shadow: 0 4px 14px 0 rgba(34, 41, 47, 0.04);
}

.homepage-content-text ::v-deep summary {
  color: #5e5873;
  cursor: pointer;
  font-weight: 600;
  line-height: 1.35;
  list-style: none;
  padding: 0.85rem 2.25rem 0.85rem 1rem;
  position: relative;
}

.homepage-content-text ::v-deep summary::-webkit-details-marker {
  display: none;
}

.homepage-content-text ::v-deep summary::after {
  border-bottom: 2px solid #6e6b7b;
  border-right: 2px solid #6e6b7b;
  content: "";
  height: 0.5rem;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-65%) rotate(45deg);
  transition: transform 0.2s ease;
  width: 0.5rem;
}

.homepage-content-text ::v-deep details[open] summary::after {
  transform: translateY(-35%) rotate(-135deg);
}

.homepage-content-text ::v-deep details p {
  margin-bottom: 0.65rem;
  padding: 0 1rem;
}

.homepage-content-text ::v-deep details p:last-child {
  margin-bottom: 0;
  padding-bottom: 1rem;
}

.homepage-content-text ::v-deep details strong {
  color: #5e5873;
  font-weight: 600;
}

.homepage-skin-dark .homepage-content-card ::v-deep .card-title,
.homepage-skin-dark .homepage-content-text ::v-deep .feature-list h3,
.homepage-skin-dark .homepage-content-text ::v-deep .homepage-column-premium .feature-list li,
.homepage-skin-dark .homepage-content-text ::v-deep summary,
.homepage-skin-dark .homepage-content-text ::v-deep details strong {
  color: #d0d2d6;
}

.homepage-skin-dark .homepage-content-text {
  color: #b4b7bd;
}

.homepage-skin-dark .homepage-content-text ::v-deep details {
  background: rgba(115, 103, 240, 0.08);
  border-color: #3b4253;
}

.homepage-skin-dark .homepage-content-text ::v-deep details[open] {
  border-color: rgba(115, 103, 240, 0.5);
  box-shadow: none;
}

.homepage-skin-dark .homepage-content-text ::v-deep summary::after {
  border-color: #b4b7bd;
}

.recent-developments-card ::v-deep .card-body {
  min-height: 100%;
}

.recent-developments-table {
  margin-bottom: 1rem;
}

.recent-developments-table ::v-deep tbody tr {
  cursor: pointer;
}

.recent-developments-table ::v-deep th,
.recent-developments-table ::v-deep td {
  vertical-align: middle;
}

.recent-developments-card ::v-deep .recent-development-date-column {
  width: 7.5rem;
}

.recent-development-details {
  background: rgba(115, 103, 240, 0.03);
  border: 1px solid #ebe9f1;
  border-radius: 0.357rem;
  padding: 1rem;
}

.recent-development-detail-heading {
  color: #5e5873;
  display: grid;
  font-weight: 600;
  gap: 0.5rem;
  grid-template-columns: 7.5rem 1fr;
  line-height: 1.35;
  margin-bottom: 0.75rem;
}

.recent-development-subtype {
  color: #7367f0;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
}

.recent-development-introduction {
  color: #6e6b7b;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 0.85rem;
}

.recent-development-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.recent-development-action-button {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  min-height: 2rem;
}

.recent-development-pdf-button {
  gap: 0.45rem;
  padding: 0.2rem 0.45rem;
}

.recent-development-pdf-icon {
  width: auto;
}

.recent-developments-pagination {
  align-items: center;
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
}

.recent-developments-pagination .custom-select {
  max-width: 5.5rem;
}

.homepage-skin-dark .recent-development-details {
  background: rgba(115, 103, 240, 0.08);
  border-color: #3b4253;
}

.homepage-skin-dark .recent-development-detail-heading {
  color: #d0d2d6;
}

.homepage-skin-dark .recent-development-introduction {
  color: #b4b7bd;
}

.home-chart-col ::v-deep .card-body {
  min-height: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
}

.home-chart-col ::v-deep .card-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.home-chart-col ::v-deep .card-text > div,
.home-chart-col ::v-deep .card-text > .echarts {
  height: 100%;
  width: 100%;
}

.home-chart-col ::v-deep .card-text .position-relative {
  flex: 1;
  min-height: 0;
}

.home-chart-col ::v-deep .card-text .echarts {
  height: 100%;
  width: 100%;
}

.card-subtitle {
  color: #6c757d;
  font-size: 1rem;
}

.statistics-explanation {
  color: #6c757d;
  font-size: 1rem;
  padding: 0 1.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
}

.statistics-body {
  padding-bottom: 1.5rem !important;
}

.statistic-subtitle {
  text-transform: capitalize;
}
</style>
